import {
  Box,
  Heading,
  Text,
  Button,
  Image,
} from '@everlywell/ui-kit';
import { Link } from 'gatsby';
import React from 'react';

interface ITwoColumnWithImage {
  eyebrow: string;
  heading: string;
  text: string;
  imageLeft: boolean;
  image: {
    file: {
      url: string;
    };
  };
  cta: {
    url: string;
    label: string;
  };
}

export const TwoColumnWithImage: React.FC<ITwoColumnWithImage> = ({
  eyebrow,
  heading,
  text,
  imageLeft,
  image,
  cta,
}) => (
  <Box bg="#f9f9f6" as="section">
    <Box
      display="flex"
      flexDirection={
        !imageLeft
          ? ['column', 'column', 'row-reverse']
          : ['column', 'column', 'row']
      }
      justifyContent="center"
      alignItems="center"
      maxWidth="1440px"
      width="100%"
      margin="0 auto"
      py={['2rem', '2rem', '4rem']}
      px={['1rem', '1rem', '1rem']}
      gap={[0, 0, '4rem']}
    >
      <Image
        src={image?.file?.url}
        alt="data-driven insights"
        width="100%"
        height="auto"
        margin="0 auto"
        maxWidth="600px"
      />
      <Box
        flex="1"
        bg="#f9f9f6"
        py={['1.25rem', '1.25rem', 0]}
        maxWidth={['none', 'none', '500px']}
        margin={[0, 0, '0 auto']}
      >
        <Box textAlign={['center', 'left', 'left']}>
          <Text
            color="#28724f"
            fontSize="1rem"
            fontWeight="400"
            lineHeight="1.5"
            mb="0.5rem"
          >
            {eyebrow}
          </Text>
          <Heading
            as="h2"
            color="#0f0f0f"
            fontSize={['2rem', '2.75rem', '2.75rem']}
            lineHeight="1.2"
            maxWidth="37.5rem"
          >
            {heading}
          </Heading>
        </Box>
        <Text
          color="#545454"
          size="lg"
          mt="1rem"
          textAlign={['center', 'left', 'left']}
        >
          {text}
        </Text>
        <Box
          display="flex"
          justifyContent={['center', 'flex-start']}
          width="100%"
        >
          <Link to={cta?.url} style={{ textDecoration: 'none' }}>
            <Button
              variant="solid"
              bg="#012b3b"
              color="#ffffff"
              size="lg"
              fontWeight="500"
              height="3.25rem"
              px="3rem"
              mt="2rem"
            >
              {cta?.label}
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  </Box>
);
